export default () => new Date().getFullYear()
